import { useState } from 'react';
import api from '../api/client';
import Modal from './Modal';

/** Кнопка: жёлтая плашка ученику на любой странице (и опционально родителю). */
export default function SendSiteNoticeButton({ studentId, studentName }) {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [includeParent, setIncludeParent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [ok, setOk] = useState('');

  function resetForm() {
    setTitle('');
    setBody('');
    setIncludeParent(false);
    setError('');
    setOk('');
  }

  async function handleSend(e) {
    e.preventDefault();
    setBusy(true);
    setError('');
    setOk('');
    try {
      const res = await api.post(`/messaging/teacher/students/${studentId}/notice/`, {
        title: title.trim(),
        body: body.trim(),
        include_parent: includeParent,
      });
      const parentCount = Number(res.data?.parent_count) || 0;
      if (includeParent && parentCount === 0) {
        setOk('Плашка у ученика. Родитель не привязан — ему не ушло.');
      } else if (parentCount > 0) {
        setOk('Плашка у ученика и родителя.');
      } else {
        setOk('Плашка у ученика.');
      }
      setTitle('');
      setBody('');
      setTimeout(() => {
        setOpen(false);
        setOk('');
      }, 900);
    } catch (err) {
      setError(
        err.response?.data?.detail
        || err.response?.data?.title
        || err.response?.data?.body
        || 'Не удалось показать плашку',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-outline"
        onClick={() => {
          resetForm();
          setOpen(true);
        }}
      >
        Плашка на сайте
      </button>
      <Modal
        open={open}
        title={`Плашка для ${studentName || 'ученика'}`}
        onClose={() => !busy && setOpen(false)}
      >
        <form onSubmit={handleSend} className="ops-form">
          <p className="muted" style={{ marginTop: 0 }}>
            Жёлтое объявление сверху на любой странице, пока не нажмут «Понятно».
            Это не переписка в «Сообщениях».
          </p>
          <label className="form-label">
            Заголовок
            <input
              className="form-input"
              type="text"
              required
              maxLength={200}
              placeholder="Оплата"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </label>
          <label className="form-label">
            Текст
            <textarea
              className="form-input"
              rows={4}
              required
              maxLength={4000}
              placeholder="Баланс ниже нуля, пополните до занятия."
              value={body}
              onChange={(e) => setBody(e.target.value)}
            />
          </label>
          <label className="form-label" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <input
              type="checkbox"
              checked={includeParent}
              onChange={(e) => setIncludeParent(e.target.checked)}
            />
            Родителю тоже
          </label>
          {error && <div className="alert alert-error">{error}</div>}
          {ok && <div className="alert alert-success">{ok}</div>}
          <div className="ops-form-actions">
            <button type="button" className="btn btn-outline" disabled={busy} onClick={() => setOpen(false)}>
              Отмена
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={busy || !title.trim() || !body.trim()}
            >
              {busy ? 'Отправка…' : 'Показать плашку'}
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
}
